<template>
  <div class="md5 clearfix">
    <div class="md5-text">
      <el-input v-model="text" type="textarea" :rows="14" cols="80" placeholder="请输入加密文本, 如: juhe.cn" />
      <ul class="text-btn clearfix">
        <el-button type="primary"  @click="save">MD5加密</el-button>
        <el-button @click="clear">清空</el-button>
      </ul>
    </div>
    <div class="md5-result">
      <div class="result-small">
        <el-button>小写</el-button>
        <el-input v-model="resultSmall" type="text" />
      </div>
      <div class="result-big">
        <el-button>大写</el-button>
        <el-input v-model="resultBig" type="text" />
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
export default {
  data () {
    return {
      text: '',
      resultSmall: '',
      resultBig: ''
    }
  },
  methods: {
    save () {
      if (this.text == '') return
      this.resultSmall = CryptoJS.MD5(this.text).toString()
      this.resultBig = this.resultSmall.toUpperCase()
    },
    clear () {
      this.text = ''
      this.resultSmall = ''
      this.resultBig = ''
    }
  }
}
</script>

<style lang="stylus" scope>
textarea, input
  border 1px solid #eee
  border-radius 2px

.md5

.md5-text
  float left
  margin-right 20px
  .text-btn
    margin-top 22px
.md5-result
  float left
  width 500px
  > .result-small, >.result-big
    margin-bottom 10px
    .el-input
      width 400px
      .el-input__inner
        border-radius 0 4px 4px 0
    .el-button
      border-right none
      border-radius 4px 0 0 4px

</style>